import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://635fbf04e8768a01d529e0c1d0311f25@o437901.ingest.us.sentry.io/4507142080823296",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});